import React from "react";
import "./Progressocial.css"; // Import the CSS

const Progressocial = ({ onClose }) => {
  return (
    <div className="floating-popup">
      <div className="popup-content">
        <button className="close-button" onClick={onClose}>
          <strong>x</strong>
        </button>
        <div className="modal-video" style={{ padding: "10px" }}>
          <h4>
            <strong>جائزة التقدم الاجتماعي لسنة 2024 🏆</strong>
          </h4>
          <p>
            تكريم شركة صاسام للصناعات من قبل السيد وزير الشؤون الاجتماعية على
            إثر تحصلها على جائزة التقدم الاجتماعي لسنة 2024.
          </p>
          <h4>
            <strong>🏆 Social Progress Award for 2024</strong>
          </h4>
          <p>
            SACEM Industries was honored by the Minister of Social Affairs for
            receiving the Social Progress Award for 2024.
          </p>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <div>
              <img
                className="img-fluid"
                src="/assets/images/actualité/home/Social Progress Award for 2024_SACEM_TRANSFORMATEUR_5.jpg"
                alt="Social Progress Award for 2024 SACEM TRANSFORMATEUR"
                style={{ maxHeight: "300px" }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Progressocial;
